var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"type-list"},_vm._l((_vm.areaList),function(area,index){return _c('li',{key:index,staticClass:"region"},[_c('nuxt-link',{attrs:{"to":_vm.url(area)}},[_vm._v("\n      "+_vm._s(area)+"のセミナー会場がある路線\n    ")])],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }